import { useEffect, useState } from "react";
import styled from "styled-components";
import { Form, Stack } from "react-bootstrap";

import { ChartInfo } from "../types/ChartInfo";

import FunctionButton from "common/components/atoms/FunctionButton";
import { NameID } from "common/types/NameID";

type Props = {
  chart: ChartInfo;
  candidates: NameID[];
  updated: (newVal: ChartInfo) => void;
  deleteRequested: () => void;
};
export const SelectGraphRow = (props: Props) => {
  const [chart, setChart] = useState<ChartInfo>();

  useEffect(() => {
    setChart(props.chart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return chart ? (
    <>
      <td style={{ verticalAlign: "middle", width: "20px" }}>
        <SDragHandle>
          <i className="fas fa-grip-vertical"></i>
        </SDragHandle>
      </td>
      <td>
        <Form.Select
          aria-label="グラフ・表"
          value={chart.chartId}
          onChange={(e) => {
            e.preventDefault();
            const newChart = { ...chart };
            newChart.chartId = +e.currentTarget.value;
            setChart(newChart);
            props.updated(newChart);
          }}
        >
          <option value={-1}>未選択</option>
          {props.candidates.map((item) => (
            <option key={`listItem_${item.id}`} value={item.id}>
              {item.name}
            </option>
          ))}
        </Form.Select>
      </td>
      <td>
        <Form.Select
          aria-label="横"
          value={chart.numCols}
          onChange={(e) => {
            e.preventDefault();
            const newChart = { ...chart };
            newChart.numCols = +e.currentTarget.value;
            setChart(newChart);
            props.updated(newChart);
          }}
        >
          {[...Array(2)].map((_, i) => (
            <option value={i + 1} key={`cols_${i}`}>
              {" "}
              {i + 1}{" "}
            </option>
          ))}
        </Form.Select>
      </td>
      <td>
        <Form.Select
          aria-label="縦"
          value={chart.numRows}
          onChange={(e) => {
            e.preventDefault();
            const newChart = { ...chart };
            newChart.numRows = +e.currentTarget.value;
            setChart(newChart);
            props.updated(newChart);
          }}
        >
          {[...Array(2)].map((_, i) => (
            <option value={i + 1} key={`rows_${i}`}>
              {" "}
              {i + 1}{" "}
            </option>
          ))}
        </Form.Select>
      </td>
      <td>
        <FunctionButton
          size="sm"
          buttonType="delete"
          className="mx-auto"
          tooltip="削除"
          onClick={(e) => {
            e.preventDefault();
            props.deleteRequested();
          }}
        >
          {<i className="fas fa-trash-alt" />}
        </FunctionButton>
      </td>
    </>
  ) : (
    <></>
  );
};

const SDragHandle = styled.div`
  display: flex;
  justify-content: center;

  color: #999;
  cursor: grab;
  user-select: none;

  &:active {
    cursor: grabbing;
  }
`;
